import {homeKeys} from '@/hooks/useHomeInfo';
import {pointsKeys} from '@/hooks/points/queryKeys';
import {benefitKeys} from '@/commerce/benefit';
import {useAuthStore} from '@/store/useAuthStore';
import {queryClient} from '@/utils/queryClient';

/**
 * SPA 内会话结束：清理 auth，并使 session 相关 query cache 失效
 * （401、无 logoutUrl 的本地登出等）
 */
export const clearAuthSession = () => {
    useAuthStore.getState().clearAuth();
    void queryClient.invalidateQueries({queryKey: homeKeys.all});
    void queryClient.invalidateQueries({queryKey: pointsKeys.personalSummary()});
    queryClient.removeQueries({queryKey: benefitKeys.all});
};
